import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function slugifyName(name) {
  return (name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

export function formatPrice(value) {
  const amount = Number(value);
  return amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
}

